import { useEffect } from 'react';
import {
  Box,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
  Breadcrumb, BreadcrumbItem, DarkMode
} from '@chakra-ui/react';
import {  } from '@chakra-ui/react';
import AppSidebar, { MobileNav } from './sidebar/AppSidebar';
import MenuLinkItems from './sidebar/MenuLinkData';
import { Outlet, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import URLConfig from '@Config/urls/url.config';
import { capitalize, hasSomeValues } from '@Shared/utils/helpers';

export default function AppLayout() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();

  const pathSnippets = window.location.pathname.split('/').filter(i => i.length);
  const breadcrumbItemColor = useColorModeValue("gray.700", "gray.200");

  const breadcrumbItems = pathSnippets.map((pageName, index) => {
    const url = `${pathSnippets.slice(0, index + 1).join('/')}`;
    return (
      <BreadcrumbItem minWidth={'fit-content'} key={url} color={breadcrumbItemColor}>
        <span>{capitalize(pageName).replace('-', ' ')}</span>
      </BreadcrumbItem>
    );
  });

  useEffect(() => {
  }, [location])
  
  return (
    <Box minH="100vh" bg={useColorModeValue('gray.100', 'gray.900')}>
        <DarkMode>
          <AppSidebar
            LinkItems={MenuLinkItems}
            onClose={() => onClose}
            display={{ base: 'none', md: 'block' }}
          />
          <Drawer
            autoFocus={false}
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            returnFocusOnClose={false}
            onOverlayClick={onClose}
            size="full"
          >
            <DrawerContent>
              <AppSidebar LinkItems={MenuLinkItems} onClose={onClose} />
            </DrawerContent>
          </Drawer>

        </DarkMode>
        {/* mobilenav */}
        <MobileNav onOpen={onOpen} />
        <Box ml={{ base: 0, md: 64 }} p="4">
          <Box overflowX={'auto'} borderRadius={'md'} mb='3' py="2" px="4" bg={useColorModeValue('gray.50', 'gray.800')}>
            <Breadcrumb color={'gray.100'}>
              {breadcrumbItems}
            </Breadcrumb>
          </Box>
          <Outlet />
        </Box>
      </Box>
  );
}
